import {createFeatureSelector, createSelector} from '@ngrx/store';
import { state } from '@angular/animations';

export const updateHeaderType = createFeatureSelector<any>('general');

export const getHeaderState = createSelector(
    updateHeaderType,
    // tslint:disable-next-line:no-shadowed-variable
  (state: any) => state.entities[1].headerType
);

export const getGeneralState = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].headerType);

export const isLoadingState = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].isLoading);

export const getSortByOption = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
    updateHeaderType, (state: any) =>  state.entities[1].sortByOption);

export const getLastRequestAsked = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
    updateHeaderType, (state: any) =>  state.entities[1].lastRequestAsked);

export const getHotelInfo = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
    updateHeaderType, (state: any) =>  state.entities[1].hotelHeaderInfo);

export const getBookingAction = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].isBookingActionEnabled);

export const getUserInfo = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].user);

export const getUnreadMessages = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].unreadMessages);

export const getActiveOffers = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) => state.entities[1].activeOffers);

export const isLoginModalOpened = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].loginModalOpened);

export const isBookNowButtonClicked = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].bookNowBtnClicked);

export const isRequestSendingEnabled = createSelector(
  // tslint:disable-next-line:no-shadowed-variable
  updateHeaderType, (state: any) =>  state.entities[1].isRequestSendEnabled);
